module.exports = {
  'en': {
    'HRES78UC1': {
      '0': '[HRES78U] Approval of Loan Request',
      '10': '[HRES78U] Approval of Loan Request',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req.Date',
      '60': 'Type Of Loan',
      '70': 'Loan Amount',
      '80': 'Currency',
      '90': 'Status',
      '100': 'Loan Pr.(y/m)',
      '110': 'Contract No.',
      '120': 'Loan Amt.',
      '130': 'Pr.(Yr./Mth.)',
      '140': 'Approve By',
      '150': 'Appr. Date',
      '160': 'Remark',
      '170': 'Next Approve',
      '180': 'For Emp. ID',
      '190': 'Approve By Next Step',
      '200': 'Approval of Loan Request',
      '260': 'Req. No.'
    },
    'HRES78UC2': {
      '0': 'Details of Approval',
      '10': 'Details of Approval',
      '20': 'For Employee',
      '30': 'Seq.no',
      '40': 'Approved By',
      '50': 'Approved date',
      '60': 'Contract No.',
      '70': 'Start date',
      '80': 'Approve Amount',
      '90': 'loan Period',
      '100': 'Yr.',
      '110': 'Month',
      '120': 'Interest Type',
      '130': 'Interest Rate',
      '140': 'Current Status',
      '150': 'Status',
      '160': 'Approved',
      '170': 'Refused',
      '180': 'Remark',
      '190': 'Repayment Trial Calc.',
      '200': 'Type Pay loan',
      '210': 'Period No.',
      '220': 'Month',
      '230': 'Year'
    },
    'HRES78UC3': {
      '0': 'History of Loan',
      '10': 'Emp. Code',
      '20': 'Contract No.',
      '30': 'Start Date',
      '40': 'Loan Amount',
      '50': 'Outstanding',
      '60': 'Closed Date',
      '70': 'Type Of Loan',
      '80': 'Max loan Period'
    },
    'HRES78UC4': {
      '0': 'Details of Loan Req.',
      '10': 'Details of Loan Req.',
      '20': 'Employee Code',
      '30': 'Input Date',
      '40': 'Type of Loan',
      '50': 'Loan Amount',
      '60': 'loan Period',
      '70': 'Yr.',
      '80': 'Month',
      '90': 'Reason of request',
      '100': 'Repayment Per period',
      '110': 'Period',
      '120': 'For Normal Period',
      '130': 'Bonus perriod',
      '140': 'Condition of Loan',
      '150': 'History of Loan',
      '160': 'Type pay loan',
      '170': 'Period No.',
      '180': 'Month',
      '190': 'Year'
    },
    'HRES78UC5': {
      '0': 'Trial Cal. of Repayment',
      '10': 'Emp. Code',
      '20': 'Loan Information',
      '30': 'Type of Loan',
      '40': 'Loan Amount',
      '50': 'Max Loan Provided',
      '60': 'BATH',
      '70': 'Request Amount',
      '80': 'BATH',
      '90': 'Loan Period',
      '100': 'Yrs.',
      '110': 'Month',
      '120': 'Interest of Loan',
      '130': 'Interest Type',
      '140': 'Interest Rate',
      '150': '%',
      '160': 'Details of Repayment',
      '170': 'Bonus Pay In Month',
      '180': '1st.',
      '190': '2nd.',
      '200': 'Start Pay in Month',
      '210': 'Bonus Rate',
      '220': '(Time Of Salary)',
      '230': 'Type of Simulate',
      '240': 'by specify  period',
      '250': 'by specify repay amount',
      '260': 'Period',
      '270': 'For Normal Period',
      '280': 'Last Repayment',
      '290': 'For Bonus Period',
      '300': '% (Salary + Bonus)',
      '310': '%',
      '320': 'Employee Data',
      '330': 'Details of Repayment'
    },
    'HRES78UC6': {
      '0': 'Employee"s Details',
      '10': 'Employee Code',
      '20': 'Status',
      '30': 'Level',
      '40': 'Hire Date',
      '50': 'Resigned Date',
      '60': 'Service Year',
      '70': 'Yrs.',
      '80': 'Month',
      '90': 'Position',
      '100': 'Job Description',
      '110': 'Department',
      '120': 'Type of Employment',
      '130': 'Type of Employee',
      '140': 'Payroll Group',
      '150': 'Work Group',
      '160': 'Education',
      '170': 'Salary'
    },
    'HRES78UC7': {
      '0': 'Details of Repayment',
      '10': 'Period',
      '20': 'Month/Year',
      '30': 'Balance Forward',
      '40': 'Principal Amt.',
      '50': 'Interest Amt.',
      '60': 'Total Amount',
      '70': 'Total',
      '80': 'Currency'
    },
    'HRES78UC8': {
      '0': 'Loan Condition',
      '10': 'Loan Condition',
      '20': 'Type of Loan',
      '30': 'Max Loan Amount',
      '40': 'Baht',
      '50': 'Or time of Salary',
      '60': 'Max Loan Period',
      '70': 'Yrs.',
      '80': 'Month',
      '90': 'Eligible Condition',
      '100': 'Qualification of Emp.'
    }
  },
  'th': {
    'HRES78UC1': {
      '0': '[HRES78U] อนุมัติการเบิกเงินกู้',
      '10': '[HRES78U] อนุมัติการเบิกเงินกู้',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ยื่นเบิก',
      '60': 'ประเภทเงินกู้',
      '70': 'วงเงินขอกู้',
      '80': 'สกุลเงิน',
      '90': 'สถานะ',
      '100': 'ระยะเวลากู้ (ปี/เดือน)',
      '110': 'เลขที่สัญญา',
      '120': 'วงเงินอนุมัติ',
      '130': 'กู้ (ปี/เดือน)',
      '140': 'ผู้อนุมัติ',
      '150': 'วันที่อนุมัติ',
      '160': 'หมายเหตุการอนุมัติ',
      '170': 'ผู้อนุมัติลำดับถัดไป',
      '180': 'สำหรับรหัสพนักงาน',
      '190': 'อนุมัติโดยข้ามขั้นตอน',
      '200': 'อนุมัติการขอเบิกเงินกู้',
      '260': 'ลำดับคำร้อง'
    },
    'HRES78UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'รายละเอียดการอนุมัติ',
      '20': 'สำหรับพนักงาน',
      '30': 'ลำดับที่อนุมัติ',
      '40': 'อนุมัติโดย',
      '50': 'วันที่อนุมัติ',
      '60': 'เลขที่สัญญา',
      '70': 'วันที่เริ่มสัญญา',
      '80': 'จำนวนเงินเบิกได้',
      '90': 'ระยะเวลากู้',
      '100': 'ปี',
      '110': 'เดือน',
      '120': 'ประเภทดอกเบี้ย',
      '130': 'อัตราดอกเบี้ย',
      '140': 'สถานะปัจจุบัน',
      '150': 'สถานะ',
      '160': 'อนุมัติ',
      '170': 'ไม่อนุมัติ',
      '180': 'หมายเหตุ',
      '190': 'ทดลองผ่อนชำระ',
      '200': 'วิธีการจ่ายเงินกู้',
      '210': 'งวดที่จ่าย',
      '220': 'เดือน',
      '230': 'ปี'
    },
    'HRES78UC3': {
      '0': 'ประวัติการกู้',
      '10': 'รหัสพนักงาน',
      '20': 'เลขที่สัญญา',
      '30': 'วันที่เริ่มต้น',
      '40': 'จำนวนเงินกู้',
      '50': 'ดอกเบี้ยค้างชำระยกไป',
      '60': 'วันที่ปิดบัญชี',
      '70': 'ประเภทเงินกู้',
      '80': 'ระยะเวลากู้สูงสุด'
    },
    'HRES78UC4': {
      '0': 'รายละเอียดการกู้',
      '10': 'รายละเอียดการกู้',
      '20': 'รหัสพนักงาน',
      '30': 'วันที่ยื่นเบิก',
      '40': 'ประเภทเงินกู้',
      '50': 'จำนวนเงินกู้',
      '60': 'ระยะเวลากู้',
      '70': 'ปี',
      '80': 'เดือน',
      '90': 'เหตุผลในการกู้',
      '100': 'จำนวนผ่อนชำระต่องวด',
      '110': 'งวดผ่อนชำระ',
      '120': 'งวดปรกติ',
      '130': 'งวดโบนัส',
      '140': 'เงื่อนไขเงินกู้',
      '150': 'ประวัติการกู้',
      '160': 'วิธีการจ่ายเงินกู้',
      '170': 'งวดที่จ่าย',
      '180': 'เดือน',
      '190': 'ปี'
    },
    'HRES78UC5': {
      '0': 'ทดลองการคำนวณผ่อนชำระ',
      '10': 'รหัสพนักงาน',
      '20': 'รายละเอียดการกู้',
      '30': 'ประเภทเงินกู้',
      '40': 'จำนวนเงินกู้',
      '50': 'วงเงินกู้สูงสุด',
      '60': 'บาท',
      '70': 'จำนวนเงินขอกู้',
      '80': 'บาท',
      '90': 'ระยะเวลากู้',
      '100': 'ปี',
      '110': 'เดือน',
      '120': 'ดอกเบี้ยเงินกู้',
      '130': 'ประเภทดอกเบี้ย',
      '140': 'อัตราดอกเบี้ย',
      '150': '%',
      '160': 'รายละเอียดการผ่อนชำระ',
      '170': 'เดือนที่จ่ายโบนัส',
      '180': 'ครั้งที่ 1',
      '190': 'ครั้งที่ 2',
      '200': 'เริ่มชำระเดือน',
      '210': 'อัตราโบนัส',
      '220': '(เท่าของเงินเดือน)',
      '230': 'ทดลองคำนวณโดย',
      '240': 'ระบุจำนวนงวด',
      '250': 'ระบุเงินผ่อนชำระ',
      '260': 'งวด',
      '270': 'งวดปรกติ',
      '280': 'ชำระครั้งสุดท้าย',
      '290': 'เงินผ่อนชำระงวดโบนัส',
      '300': '% (เงินเดือน + โบนัส)',
      '310': '%',
      '320': 'ข้อมูลพนักงาน',
      '330': 'รายละเอียดทดลองผ่อนชำระ'
    },
    'HRES78UC6': {
      '0': 'รายละเอียดพนักงาน',
      '10': 'รหัสพนักงาน',
      '20': 'สถานะ',
      '30': 'ระดับ',
      '40': 'วันที่เริ่มงาน',
      '50': 'วันที่ลาออก',
      '60': 'อายุงาน',
      '70': 'ปี',
      '80': 'เดือน',
      '90': 'ตำแหน่ง',
      '100': 'ลักษณะงาน',
      '110': 'หน่วยงาน',
      '120': 'ประเภทการจ้างงาน',
      '130': 'ประเภทพนักงาน',
      '140': 'กลุ่มการจ่ายเงินเดือน',
      '150': 'กลุ่มพนักงาน',
      '160': 'การศึกษา',
      '170': 'เงินเดือน'
    },
    'HRES78UC7': {
      '0': 'รายละเอียดการผ่อนชำระ',
      '10': 'งวด',
      '20': 'เดือน/ปี',
      '30': 'เงินต้นยกมา',
      '40': 'เงินต้น',
      '50': 'ดอกเบี้ย',
      '60': 'รวมผ่อนชำระ',
      '70': 'รวม',
      '80': 'สกุลเงิน'
    },
    'HRES78UC8': {
      '0': 'เงื่อนไขเงินกู้',
      '10': 'เงื่อนไขเงินกู้',
      '20': 'ประเภทเงินกู้',
      '30': 'วงเงินกู้สูงสุด',
      '40': 'บาท',
      '50': 'จำนวนเท่าเงินเดือน',
      '60': 'ระยะเวลากู้สูงสุด',
      '70': 'ปี',
      '80': 'เดือน',
      '90': 'เงื่อนไขสำหรับพนักงาน',
      '100': 'คุณสมบัติพนักงาน'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres78u.js